module.exports = __webpack_public_path__ + "media/O_talk.50ddd2ec.mp3";